import Moment from 'moment-timezone';

import { ajaxFetch } from '~/dashboard/helpers';
import { routes } from '~/helpers/routes';

// This function grabs the timezone data from the browser for setting in the backend when
// the user successfully logs in. Relative timestamps in the dashboard will then be based on
// these values for the life of the user's session.
export const getTimezoneAuthData = () => ({
  tz_offset: new Date().getTimezoneOffset() * -1,
  tz: Moment.tz.guess(),
});

export const VERIFICATION_ID_KEY = 'mfaVerificationSID';

export const cancelExistingVerification = async () => {
  const verificationSID = window.localStorage.getItem(VERIFICATION_ID_KEY);
  if (verificationSID) {
    // If a verification already exists, we need to cancel it before we create a new one
    try {
      await ajaxFetch(routes.authentication.mfa.cancelVerification(verificationSID), 'POST');
    } catch (error) {
      // Do nothing
    }
    window.localStorage.removeItem(VERIFICATION_ID_KEY);
  }
};

export const validateVanityUrl = (urlParams?: { vanity_url?: string }) => {
  let isValidVanityUrl = false;
  if (urlParams?.vanity_url) {
    const vanityUrlRedirect = decodeURIComponent(urlParams.vanity_url as string);
    // valid vanity url should be from a subdomain of .alloy.com
    // example: https://organization-slug.app.alloy.com
    isValidVanityUrl = /^https?:\/\/[^/]+\.alloy\.com/.test(vanityUrlRedirect);
  }
  return isValidVanityUrl;
};
